import 'htmx.org'

function initCampaignManagePage() {
  const navSelect = document.getElementById('manage-nav-select')

  navSelect?.addEventListener('change', (event) => {
    const path = (event.target as HTMLSelectElement).value
    if (path) window.location.href = path
  })
}

document.addEventListener('DOMContentLoaded', initCampaignManagePage)
document.addEventListener('htmx:afterSwap', (event) => {
  if ((event as CustomEvent).detail.target === document.body) {
    initCampaignManagePage()
  }
})
